import React from 'react';
import '../../styles/ExpenseList.scss';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import {Fab} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ExpenseListItem from './ExpenseListItem';

function ExpenseListLoading() {
  const Row = (key) => <div className="expense-row" key={key}>
    <span className="date"><Skeleton width="25%"/></span>
    <span className="info-text">
      <span className="category"><Skeleton width="50%"/></span>
      <span className="description"><Skeleton width="75%"/></span>
    </span>
    <span className="amount">
      <span className="amount-primary"><Skeleton width="75%"/></span>
      <span className="amount-secondary"><Skeleton width="55%"/></span>
    </span>
  </div>;
  return <>
    <Row key="loading-1" />
    <Row key="loading-2" />
    <Row key="loading-3" />
    <Row key="loading-4" />
    <Row key="loading-5" />
    <Row key="loading-6" />
    </>
}
function ExpenseList({data, isLoading}) {
  const dateFormatter = new Intl.DateTimeFormat('en-US');

  // Group expenses by date
  const groupExpensesByDate = (expenses) => {
    if (!expenses) return {};

    return expenses.reduce((groups, expense) => {
      try {
        const dateKey = dateFormatter.format(expense.date);
        if (!groups[dateKey]) {
          groups[dateKey] = [];
        }
        groups[dateKey].push(expense);
      } catch (ex) {
        console.error('Error grouping expense by date:', ex);
        // Handle invalid dates by putting them in an "Unknown Date" group
        if (!groups['Unknown Date']) {
          groups['Unknown Date'] = [];
        }
        groups['Unknown Date'].push(expense);
      }
      return groups;
    }, {});
  };

  const dateGroups = data && !isLoading ? groupExpensesByDate(data) : {};

  return <div className="expense-list">
    {data && !isLoading
      ? Object.entries(dateGroups).map(([date, expenses]) => (
          <div key={date} className="expense-date-group">
            <div className="expense-date-header">{date}</div>
            {expenses.map((r) => <ExpenseListItem key={r.rowNumber} item={r} />)}
          </div>
        ))
      : <ExpenseListLoading/>
    }
    <Fab color="primary" aria-label="add" href="/expenses/add" key="fab">
      <AddIcon />
    </Fab>
  </div>;
}

export default ExpenseList;
export {
  ExpenseListItem
};
